<template>
  <div id="columnManagerDiv">
    <select :size="10" id="columnSelect" ref="columnSelect" @change="selectChange" multiple>
      <option v-for="(column, index) in mainChart.orderedCols.value" :key="index" :active="true">
        {{ `${index}: ${column.name}` }}</option>
    </select>
    <div id="columnDetails">
      <button @click="addChartColumn">add new column</button><br>
      <hr>
      <div v-if="selectedColumns != null && selectedColumns.length > 0">
        <p>selected column: {{ selectedIndexes }}</p>
        <div style="display: flex; justify-content: space-between; width: 100%;">
          index: <input type="number" step="1" :value="selectedColumnIndex" @input="setColumnIndex" /></div>
        <div style="display: flex; justify-content: space-between; width: 100%;">
          name: <input type="text" :value="selectedParameters[0].name" @input="e => setParameter('name', e.target.value)" /></div>
        <div style="display: flex; justify-content: space-between; width: 100%;">
          colour: <input type="color" :value="selectedParameters[0].colour" @input="e => setParameter('colour', e.target.value)" /></div>
        <div id="columnParameterManagerDiv">
          <div v-for="[key, value] in Object.entries(selectedParameters[1])" :key="key"
            style="display: flex; justify-content: space-between; width: 100%;">
            <button @click="removeParameter(key)">x</button>
            {{ key }} :
            <input type="text" @input="e => setParameter(key, e.target.value)" :value="value" />
          </div>
          <div>
            <input type="text" ref="newKeyTxtBox" />
            <button @click="addParameter()">add key</button>
          </div>
        </div>
      </div>
      <div v-else>no column selected</div>
      <br>
      <hr>
      <button @click="removeChartColumn">remove selected columns</button><br>
    </div>


  </div>
</template>

<script setup>
import { useTemplateRef, triggerRef, computed, inject, shallowRef } from 'vue';
import { useLogStore } from '../../stores/LogStore';
import { commonAttributes } from '@/util/utilFunctions';

const mainChart = inject('mainChart')
const { columns } = mainChart

const logStore = useLogStore()
const LOG_GROUP = "Columns"

const selectedColumns = shallowRef([])

const selectedIndexes = computed(() => {
  columns.value

  return selectedColumns.value.map(e => e.columnIndex).join(', ')
})

// details
const selectedParameters = computed(() => {
  const cAttrs = commonAttributes(selectedColumns.value)
  const { columnId, name, colour, columnIndex, ...others } = cAttrs

  return [{ columnId, name, colour: colour ?? '#FFFFFF', columnIndex }, others]
})

const selectedColumnIndex = computed(() => {
  columns.value
  return selectedColumns.value?.[0]?.columnIndex ?? ""
})

// actions / selection
const selectChange = e => {
  selectedColumns.value = Array.from(e.target.selectedOptions).map(e => mainChart.orderedCols.value[e.index])
}

const addChartColumn = () => {
  mainChart.addChartColumn()
  logStore.sendLog(LOG_GROUP, `Added column ${columns.value.length}`)
}

const removeChartColumn = () => {
  for(let i = selectedColumns.value.length - 1; i >= 0; i--){
    mainChart.removeChartColumn(selectedColumns.value[i].columnId)
    logStore.sendLog(LOG_GROUP, `Removed column ${selectedColumns.value[i].columnIndex}`)
  }
  selectedColumns.value = []
}


// actions / parameters
const newKeyTxtBox = useTemplateRef("newKeyTxtBox")
const addParameter = () => {
  let key = newKeyTxtBox.value.value
  selectedColumns.value.forEach(x => {
    mainChart.setColumnParameter(x.columnId, key, "")
  })
  triggerRef(selectedColumns)
}

const removeParameter = (key) => {
  selectedColumns.value.forEach(x => {
    mainChart.setColumnParameter(x.columnId, key, null)
  })
  triggerRef(selectedColumns)
}

const setParameter = (key, value) => {
  selectedColumns.value.forEach(x => {
    mainChart.setColumnParameter(x.columnId, key, value)
  })
  triggerRef(selectedColumns)
}

const setColumnIndex = e => {
  mainChart.moveChartColumns(selectedColumns.value, e.target.value)
}

</script>

<style scoped>
#columnManagerDiv {
  display: flex;
}

#columnManagerDiv option[active="true"] {
  background: rgb(255, 255, 255);
}

#columnSelect {
  width: 100px
}

#columnDetails {
  display: block;
}
</style>